import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Trash2, UploadCloud } from 'lucide-react';

const AdminGallery = () => {
  const [images, setImages] = useState([]);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/gallery`);
      setImages(data);
    } catch (e) { console.error(e); }
  };

  const handleUpload = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    setUploading(true);
    const data = new FormData();
    data.append('image', selectedFile);
    
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/gallery`, data, { withCredentials: true });
      fetchGallery();
    } catch (err) { alert("Yükleme başarısız."); }
    finally { setUploading(false); setFile(null); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Görseli silmek istediğinize emin misiniz?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/gallery/${id}`, { withCredentials: true });
      fetchGallery();
    } catch (err) { alert("Hata oluştu."); }
  };

  return (
    <div>
      <div className="mb-8 bg-white p-6 rounded-2xl border border-slate-200 flex flex-col items-center justify-center text-center">
        <UploadCloud size={48} className="text-blue-500 mb-4" />
        <h3 className="text-lg font-bold text-slate-800 mb-2">Yeni Görsel Yükle</h3>
        <p className="text-sm text-slate-500 mb-6">Galeri sayfasında gösterilmek üzere fotoğraf yükleyin.</p>
        <label className="relative cursor-pointer bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium transition-colors">
          {uploading ? 'Yükleniyor...' : 'Bilgisayardan Seç'}
          <input type="file" className="hidden" accept="image/*" onChange={handleUpload} disabled={uploading} />
        </label>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {images.map(img => (
          <div key={img._id} className="relative group rounded-xl overflow-hidden aspect-square bg-slate-100 border border-slate-200">
            <img 
              src={img.image_url.startsWith('http') ? img.image_url : `${process.env.REACT_APP_BACKEND_URL}${img.image_url}`} 
              alt="Gallery" 
              className="w-full h-full object-cover" 
            />
            <div className="absolute inset-0 bg-slate-900/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <button 
                onClick={() => handleDelete(img._id)}
                className="w-12 h-12 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 hover:scale-110 transition-all shadow-lg"
              >
                <Trash2 size={20} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminGallery;
